export const REMOVE_ITEM = "REMOVE_ITEM"
export const ADD_ITEM = "ADD_ITEM"
export const MODIFY_ARRAY = "MODIFY_ARRAY"
export const SET_ACTIVE_TOKEN = "SET_ACTIVE_TOKEN"
export const MODIFY_TOKEN_COUNTER = "MODIFY_TOKEN_COUNTER"
export const SWITCH_TOKEN_TYPE = "SWITCH_TOKEN_TYPE"
